import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './CookieConsent.css'

const STORAGE_KEY = 'cookie-consent'
export type CookieConsentValue = 'all' | 'essential'

/** Сохранённый выбор пользователя по cookie (или null, если ещё не выбирал). */
export const getCookieConsent = (): CookieConsentValue | null => {
  const v = localStorage.getItem(STORAGE_KEY)
  return v === 'all' || v === 'essential' ? v : null
}

/**
 * GDPR cookie-consent баннер. Показывается, пока пользователь не сделал выбор.
 * По умолчанию (до согласия) — только essential cookie; «Accept all» включает
 * необязательные. Выбор хранится в localStorage.
 */
const CookieConsent = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setVisible(getCookieConsent() === null)
  }, [])

  const choose = (value: CookieConsentValue) => {
    localStorage.setItem(STORAGE_KEY, value)
    setVisible(false)
    window.dispatchEvent(
      new CustomEvent('cookie-consent-change', { detail: value }),
    )
  }

  if (!visible) return null

  return (
    <div className="cookie-consent" role="dialog" aria-label="Cookie consent">
      <p className="cookie-consent__text">
        We use cookies to run this site and, with your consent, to improve it.
        You can accept all cookies or keep only the essential ones. See our{' '}
        <Link to="/privacy" className="cookie-consent__link">
          Privacy&nbsp;Policy
        </Link>
        .
      </p>
      <div className="cookie-consent__actions">
        <button
          type="button"
          className="cookie-consent__btn cookie-consent__btn--ghost"
          onClick={() => choose('essential')}
        >
          Essential only
        </button>
        <button
          type="button"
          className="cookie-consent__btn cookie-consent__btn--primary"
          onClick={() => choose('all')}
        >
          Accept all
        </button>
      </div>
    </div>
  )
}

export default CookieConsent
